/**
 * @generated SignedSource<<e027d477cf046792ea9e8122ee035083>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLOnboardingTaskId = "CHAT_WITH_TIERZERO" | "CONNECT_CODE" | "CONNECT_DOCUMENTATION" | "CONNECT_MESSAGING" | "CONNECT_ONCALL" | "CONNECT_TELEMETRY" | "CREATE_AND_RUN_FIRST_DIGEST" | "CREATE_FIRST_ALERT_RESPONDER" | "INSPECT_INTEGRATION_RESOURCES" | "INTEGRATION_SETUP" | "KNOWLEDGE_SETUP" | "LEARN_ALERT_RESPONDER" | "LEARN_CHAT" | "LEARN_DIGEST" | "MANAGE_MEMORY" | "SETUP_INTEGRATIONS" | "SETUP_TEAM" | "TIERZERO_MD_SETUP" | "TIERZERO_USER_GUIDE" | "%future added value";
export type GraphQLOnboardingTaskStatusEnum = "COMPLETED" | "PENDING" | "TODO" | "TO_REVIEW" | "%future added value";
export type CreateOnboardingTaskStatusInput = {
  status: GraphQLOnboardingTaskStatusEnum;
  taskId: GraphQLOnboardingTaskId;
  teamId: any;
};
export type EmptyChatsCreateOnboardingTaskStatusMutation$variables = {
  input: CreateOnboardingTaskStatusInput;
};
export type EmptyChatsCreateOnboardingTaskStatusMutation$data = {
  readonly createOnboardingTaskStatus: {
    readonly taskStatus: {
      readonly id: any;
      readonly status: GraphQLOnboardingTaskStatusEnum;
      readonly taskId: GraphQLOnboardingTaskId;
    };
  };
};
export type EmptyChatsCreateOnboardingTaskStatusMutation = {
  response: EmptyChatsCreateOnboardingTaskStatusMutation$data;
  variables: EmptyChatsCreateOnboardingTaskStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOnboardingTaskStatusPayload",
    "kind": "LinkedField",
    "name": "createOnboardingTaskStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLOnboardingTaskStatus",
        "kind": "LinkedField",
        "name": "taskStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmptyChatsCreateOnboardingTaskStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmptyChatsCreateOnboardingTaskStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e3d0cc3fac7b6a4872aed75cdfe7855",
    "id": null,
    "metadata": {},
    "name": "EmptyChatsCreateOnboardingTaskStatusMutation",
    "operationKind": "mutation",
    "text": "mutation EmptyChatsCreateOnboardingTaskStatusMutation(\n  $input: CreateOnboardingTaskStatusInput!\n) {\n  createOnboardingTaskStatus(input: $input) {\n    taskStatus {\n      id\n      taskId\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "954fcc5c86dad662d69dd481ee10563f";

export default node;
